import { WixConnect } from 'widget/player-widget/utils/wix-connect';

import Icon from 'widget/player-widget/components/icon/icon';

import styles from './closable-overlay.styl';


@WixConnect(styles)
export default class ClosableOverlay extends React.Component {

  static propTypes = {
    children: React.PropTypes.any,
    onClose: React.PropTypes.func,
  };

  get closeButton() {
    const { onClose } = this.props;

    return (
      <Icon styleName="close"
            data-hook="closeOverlay"
            name="exit"
            onClick={onClose} />
    );
  }

  render() {
    const { children } = this.props;

    return (
      <div styleName="overlay">
        {this.closeButton}
        <div styleName="content">
          {children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/closable-overlay/closable-overlay.js